/**
 *  Poker Blast widget AppId for 888
 *  @type {String}
 */
export const POKER_BLAST_WIDGET = 'POKER_GAMES_WIDGET';

/**
 *  Poker Blast widget container id
 * @type {String}
 */
export const POKER_BLAST_CONTAINER_ID = 'PokerBlastContainer';

/**
 *  Poker Blast widget source app id
 * @type {String}
 */
export const POKER_BLAST_SOURCE_APP_ID = 'SPORT_OFFERING';

/**
 * Poker Blast channel type
 * @type {String}
 */
export const POKER_BLAST_CHANNEL_TYPE = 'widget';

/**
 * Poker Blast source info for 888
 * @type {String}
 */
 export const POKER_BLAST_SOURCE = 'spectate';
